(() => {
  if (customElements.get('tm-back-to-top')) return;
  class TmBackToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.controller = new AbortController();
      this.frame = 0;
      this.flightFrame = 0;
      this.flying = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.controller.signal;
      this.update = () => {
        this.frame = 0;
        if (this.flying && window.scrollY === 0) {
          this.finish();
          return;
        }
        this.setVisible(this.flying || window.scrollY >= 400);
      };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };
      this.finish = () => {
        if (!this.flying) return;
        this.flying = false;
        clearTimeout(this.flightTimeout);
        cancelAnimationFrame(this.flightFrame);
        this.flightFrame = 0;
        this.removeAttribute('data-flying');
        // Keep keyboard navigation at the destination when the control disappears.
        if (window.scrollY <= 2 && document.activeElement === this.button) {
          const destination = document.querySelector('#header-component a.header-logo, #header-component .header-logo a');
          destination?.focus({ preventScroll: true });
        }
        this.toggleAttribute('data-arrived', window.scrollY <= 2);
        this.setVisible(window.scrollY >= 400);
      };
      this.button.addEventListener('click', () => {
        if (this.flying) return;
        this.flying = true;
        this.setAttribute('data-flying', '');
        this.flightTimeout = setTimeout(this.finish, 2500);
        const startY = window.scrollY;
        const startX = window.scrollX;
        if (this.reducedMotion.matches) {
          window.scrollTo({ top: 0, left: startX, behavior: 'instant' });
          this.finish();
          return;
        }
        // Own the timing; every frame is immediate so browser smooth-scroll cannot restart or jump.
        window.scrollTo({ top: startY, left: startX, behavior: 'instant' });
        const duration = Math.min(1400, Math.max(900, 750 + startY * 0.12));
        const startedAt = performance.now();
        const fly = (now) => {
          if (!this.flying) return;
          const progress = Math.min(1, (now - startedAt) / duration);
          const eased = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
          window.scrollTo({ top: Math.round(startY * (1 - eased)), left: startX, behavior: 'instant' });
          if (progress < 1) {
            this.flightFrame = requestAnimationFrame(fly);
          } else {
            this.finish();
          }
        };
        this.flightFrame = requestAnimationFrame(fly);
      }, { signal });
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      window.addEventListener('wheel', this.finish, { passive: true, signal });
      window.addEventListener('touchstart', this.finish, { passive: true, signal });
      window.addEventListener('keydown', (event) => {
        if (['Escape', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End'].includes(event.key)) this.finish();
      }, { signal });
      this.update();
    }
    setVisible(visible) {
      if (visible) this.removeAttribute('data-arrived');
      this.button.disabled = !visible;
      this.hidden = !visible;
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.flightFrame);
      clearTimeout(this.flightTimeout);
    }
  }
  customElements.define('tm-back-to-top', TmBackToTop);
})();
